import React, { Component } from "react";
import {withRouter } from "react-router-dom";

import "./App.css";

import Routes from "./Routes";
import { Auth } from "aws-amplify";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Menu, { SubMenu, Item as MenuItem } from 'rc-menu';
import { Link } from 'react-router-dom';
//import 'rc-menu/assets/index.css';
import "./theme.css";
import swal from 'sweetalert';
import 'sweetalert/dist/sweetalert.css';
import { Button, ButtonGroup, ButtonToolbar} from 'reactstrap';
import SvgIcon from 'react-icons-kit';
import {home} from 'react-icons-kit/icomoon/home'
import WaitingModal from './containers/generics/WaitingModal';
import {forward} from 'react-icons-kit/icomoon/forward';


import {statsDots} from 'react-icons-kit/icomoon/statsDots'
import {office} from 'react-icons-kit/icomoon/office'
import ModalPassword from './containers/generics/ModalPassword';


import {userPlus} from 'react-icons-kit/icomoon/userPlus';
import {lab} from 'react-icons-kit/icomoon/lab';
import {cogs} from 'react-icons-kit/icomoon/cogs';
import {desktop} from 'react-icons-kit/fa/desktop';
import {ic_cached} from 'react-icons-kit/md/ic_cached';
import {eyedropper} from 'react-icons-kit/icomoon/eyedropper';
import {users} from 'react-icons-kit/icomoon/users';
import {exit} from 'react-icons-kit/icomoon/exit';
import {user} from 'react-icons-kit/icomoon/user';
import {cog} from 'react-icons-kit/icomoon/cog';

import IdleTimer from 'react-idle-timer';
import $ from 'jquery';


var Config = require('./config');
var socket = "";
var session = sessionStorage.getItem('health_facilities_name');


function onOpenChange(value) {
 //console.log('onOpenChange', value);
}



class App extends Component {
	constructor(props) {
		super(props);
		this.updatePermissions = this.updatePermissions.bind(this);

		this.handleClick = this.handleClick.bind(this);
		this.generateReport = this.generateReport.bind(this);
		this.reload = this.reload.bind(this);
		this.changePwd = this.changePwd.bind(this);
		this.getLookFeel = this.getLookFeel.bind(this);
		this.onIdle = this.onIdle.bind(this);
		this.getDocumentType = this.getDocumentType.bind(this);
		this.printDocumentTemplate = this.printDocumentTemplate.bind(this);
		this.printDocumentExternal = this.printDocumentExternal.bind(this);
		this.getServices = this.getServices.bind(this);
		this.setPermissionsMenu = this.setPermissionsMenu.bind(this);
		this.printLabel = this.printLabel.bind(this);
		this.openSocket = this.openSocket.bind(this);
		
		this.state = {
			isAuthenticated: false,
			isAuthenticating: true,
			task_vital_signs:{},
			task_biometrics:{},
			task_clinic_history:{},
			task_extraction:{},
			task_register:{},
			task_general_summary:{},
			task_release_lock:{},
			task_screen_caller:{},
			task_validation_donation:{},
			task_results_donation:{},
			task_lab_antibodies:{},
			task_lab_phenotypes:{},
			task_has_user_profiles:[],
			lab_sections_has_user_profiles:[],
			medical_staff:{},
			task_unit_request:{},
			task_unit_send:{},
			search:"",
			columns:[],
			don_usr_llam:"",
			machine_name:"-------",
			waiting:"",
			task_centrifuge:{},
			task_division:{},
			task_transformation:{},
			task_alicuots:{},
			task_pools:{},
			task_recostitution:{},
			task_cryoprecipitates:{},
			task_discard_units:{},
			permissions:[],

			task_external_bags:{},
			task_donor_samples:{},
			task_sample_results:{},
		
			task_petitions:{},
			task_patient_sample_results:{},
			task_inactive_plasma:{},
			task_unit_entries:{},
			show_menu:{},

			hiddeToReport: false,

			api_version:"",
			logo_1:"",
			w_logo1:"",
			logo_2:"",
			w_logo2:"",
			header_document:"",
			w_head:"",
			background_color:"",
			font_color:"",
			icon_color:"",

			task_plasmatic_product:{},
			task_plasmatic_entries:{},
			task_plasmatic_p_storage:{},
			task_plasmatic_p_discard:{},
			task_promotion_campaign:{},
			task_promotion_external_bags:{},
			line_warehouse:false,
			task_units_locked:{},
			task_unit_transfer:{},
			task_summary_campaigns:{},

			task_unit_delivered:{},
			task_unit_reserves:{},
			preview_print:{},
			graphics:[],
			supplies_storage:{},
			supplies_entries:{},
			supplies:{},
			supplies_discards:{},
			supplies_output:{},
			menu:[
				{
					title:'DONANTES',
					submenu:[
						{
							title:'REPORTES',
							report:true,
							submenu:[
								{title:'Control de Tiempo', show:true, search:'time_control', link:'/time_control', permission:'TIME_CONTROL'},
								{title:'Directorio Donantes', show:true, search:'directory_donor', link:'/directory_donor', permission:'DONOR_DIRECTORY'},
								{title:'Donaciones con Incidentes de Extracción', show:true, search:'extraction_incident', link:'/extraction_incident', permission:'EXTRACTION_INCIDENTS'},
								{title:'Donaciones con Incidentes de Serología', show:true, search:'serology_incidents', link:'/serology_incidents', permission:'SEROLOGY_INCIDENTS'},
								{title:'Donaciones por Centro', show:true, search:'donations_by_center', link:'/donations_by_center', permission:'DONATIONS_BY_CENTER'},
								{title:'Donaciones Registradas', show:true, search:'donation_register', link:'/donation_register', permission:'DONATIONS_REGISTERED'},
								{title:'Donantes Edad y Género', show:true, search:'donor_age_gender', link:'/donor_age_gender', permission:'DONORS_AGE_GENDER'},
								{title:'Donantes por Lugar de Colecta', show:true, search:'donors_convoke_place', link:'/donors_convoke_place', permission:'DONORS_BY_CONVOKE_PLACES'},
								{title:'Donantes por Servicio', show:true, search:'donor_by_service', link:'/donor_by_service', permission:'DONORS_BY_SERVICE'},
								{title:'Información General', show:true, search:'general_info', link:'/general_info', permission:'GENERAL_INFORMATION'},
								{title:'Informe de Hematología', show:true, search:'hematologia_report', link:'/hematologia_report', permission:'BIOMETRIC_PRODUCTIVITY'},
								{title:'Libreta Estudio de Donador', show:true, search:'donor_study', link:'/donor_study', permission:'DONOR_STUDY_NOTEBOOK'},
								{title:'Libreta Ingresos', show:true, search:'income_book', link:'/income_book', permission:'INCOME_BOOK'},
								{title:'Productividad Extracción', show:true, search:'nurse_productivity', link:'/nurse_productivity', permission:'NURSE_PRODUCTIVITY'},
								{title:'Productividad Médica', show:true, search:'medical_productivity', link:'/medical_productivity', permission:'MEDICAL_PRODUCTIVITY'},
								{title:'Productividad Médica Detallada', show:true, search:'medical_productivity_detail', link:'/medical_productivity_detail', permission:'MEDICAL_PRODUCTIVITY_DETAILS'},
								{title:'Reacciones a Donación', show:true, search:'reaction_donations', link:'reaction_donations', permission:'DONATION_REACTIONS'},								
								{title:'Reporte CNTS', show:true, search:'cnts_report', link:'/cnts_report', permission:'CNTS_REPORT'},
								{title:'Reportes Especiales', show:true, search:'special_queries', link:'/special_queries', permission:'DIRECT_QUERIES'},
								{title:'Resumen Donaciones', show:true, search:'donation_summary', link:'/donation_summary', permission:'DONATIONS_SUMMARY'},
							]
						},
						{
							title:'ESTADÍSTICA',
							report:true,
							submenu:[
								{title:'Estadística de Donadores por Centro', show: true, search:'donor_by_center', link:'/donor_by_center', permission:'DONATIONS_BY_CENTER_STATS'},
								{title:'Estadística de Donadores', show: true, search:'stats_donors', link:'/stats_donor', permission:'DONATION_STATS'},
							]
						},
						{title:'PRINCIPAL', submenu:[
							{title:'Reimpresión de Etiquetas Múltiple', show:true, search:'multiple_reprint', link:'/multiple_reprint', permission:'MULTI_REPRINT_LABELS'},
						], report:false}
					]
				}
			]
		};
	}

	/* FUNCIONA */
	handleClick(info){
		var search = info.item.props.search ? info.item.props.search : '';
		var valid = true;

		switch(search){
			case 'logo':
			case 'none':
				valid = false;
				break;
			case 'pass_change':
				valid = false;

				this.changePwd();
				break;
			case 'singout':
				valid = false;

				this.handleLogout();
				break;
			case 'promotion/offers':
				search = 'campaings';
				break;
			case '':
				valid = false;
				this.generateReport();
	
			default:
				valid = true;
				break;
		}

		if(valid){
			this.setState({search:search === 'campaings' ? 'promotion/offers' : search});

			this.props.history.push('/');
			setTimeout(()=>{
				this.props.history.replace('/'+(search === 'campaings' ? 'promotion/offers' : search));
			}, 0);
			
			if(search !== 'no_search'){
				fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search='+search,{ 
			        method: 'get',
			        headers: new Headers({
			           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			           'Accept': 'application/json',
			            'Content-Type': 'application/json',
			        })
			    })
			        .then(response => response.json())
			      	.then(response => {
			        	if(response !== undefined){
			          		this.setState({ columns: response });
			       	}
			    })
			}

			this.getServices();

		}
		 //this.updatePermissions();
	}

	getServices(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=lab_preview_print&x=',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				preview_print: response
			});
		})



		fetch(Config.default.apiGateway.URL+'units/get_unit_expired?hf_id='+
			sessionStorage.getItem("health_facilities_id")+'&option=x',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		  .then(response => {
			if(response !== undefined){
				  if(response){
					this.setState({ line_warehouse: response });
				}

			   }
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=GEN_MIN_LOG_OUT&x=',{ 
		  method: 'get',
		  headers: new Headers({
			'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		  })
		})
		.then(response => response.json())
		.then(response => {
			this.idleTimer.reset();
			  sessionStorage.setItem("min_logout", response.value);
		});
	}
	
	componentDidMount() {
				
		
		try {
			
			if (sessionStorage.getItem("token")!== undefined && sessionStorage.getItem("token")!== null && sessionStorage.getItem("token")!== "") {
				this.openSocket();
				this.getLookFeel();
				this.userHasAuthenticated(true);
				this.updatePermissions();

				this.getServices();

				//if(this.state.background_color === ""){
					
				//}
			}else{
				///this.updatePermissions(); ???
				//this.getLookFeel();
				if(this.props.location.pathname.indexOf('/change_list') === -1){
					this.props.history.push("/login");
				}
			}
		}
		catch(e) {
			if (e !== 'No current user') {
				swal('Error', e,'error');
			}
		}

		//this.getLookFeel();

		this.setState({ isAuthenticating: false });

		if(JSON.parse(sessionStorage.getItem("task_vital_signs") !== null)){
			this.setState({
		      task_vital_signs:JSON.parse(sessionStorage.getItem("task_vital_signs")),
		      task_biometrics:JSON.parse(sessionStorage.getItem("task_biometrics")),
		      task_clinic_history:JSON.parse(sessionStorage.getItem("task_clinic_history")),
		      task_extraction:JSON.parse(sessionStorage.getItem("task_extraction")),
		      task_register:JSON.parse(sessionStorage.getItem("task_register")),
		      task_general_summary:JSON.parse(sessionStorage.getItem("task_general_summary")),
			  task_release_lock:JSON.parse(sessionStorage.getItem("task_release_lock")),
			  task_screen_caller:JSON.parse(sessionStorage.getItem("task_screen_caller")),
			  task_results_donation:JSON.parse(sessionStorage.getItem("task_results_donation")),
			  task_validation_donation: JSON.parse(sessionStorage.getItem("task_validation_donation")),
			  task_lab_antibodies: JSON.parse(sessionStorage.getItem("task_lab_antibodies")),
			  task_lab_phenotypes: JSON.parse(sessionStorage.getItem("task_lab_phenotypes")),
			  task_has_user_profiles: JSON.parse(sessionStorage.getItem("task_has_user_profiles")),
			  lab_sections_has_user_profiles: JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles")),
			  medical_staff: JSON.parse(sessionStorage.getItem("medical_staff")),
			  task_unit_request: JSON.parse(sessionStorage.getItem("task_unit_request")),
			  task_unit_send: JSON.parse(sessionStorage.getItem("task_unit_send")),
			  task_centrifuge:JSON.parse(sessionStorage.getItem("task_centrifuge")),
			  task_division:JSON.parse(sessionStorage.getItem("task_division")),
			  task_transformation:JSON.parse(sessionStorage.getItem("task_transformation")),
			  task_alicuots:JSON.parse(sessionStorage.getItem("task_alicuots")),
			  task_pools:JSON.parse(sessionStorage.getItem("task_pools")),
			  task_recostitution:JSON.parse(sessionStorage.getItem("task_recostitution")),
			  task_cryoprecipitates:JSON.parse(sessionStorage.getItem("task_cryoprecipitates")),
			  task_discard_units:JSON.parse(sessionStorage.getItem("task_discard_units")),
			  task_external_bags:JSON.parse(sessionStorage.getItem('task_external_bags')),
			  task_donor_samples:JSON.parse(sessionStorage.getItem('task_donor_samples')),
			  task_sample_results:JSON.parse(sessionStorage.getItem('task_sample_results')),
			  task_petitions:JSON.parse(sessionStorage.getItem('task_petitions')),
			  task_patient_sample_results:JSON.parse(sessionStorage.getItem('task_patient_sample_results')),
			  task_inactive_plasma:JSON.parse(sessionStorage.getItem('task_inactive_plasma')),
			  task_unit_entries:JSON.parse(sessionStorage.getItem('task_unit_entries')),
			  task_plasmatic_product:JSON.parse(sessionStorage.getItem('task_plasmatic_product')),
			  task_plasmatic_entries:JSON.parse(sessionStorage.getItem('task_plasmatic_entries')),
			  task_plasmatic_p_storage:JSON.parse(sessionStorage.getItem('task_plasmatic_p_storage')),
			  task_promotion_campaign:JSON.parse(sessionStorage.getItem('task_promotion_campaign')),
			  task_promotion_external_bags:JSON.parse(sessionStorage.getItem('task_promotion_external_bags')),
			  task_plasmatic_p_discard:JSON.parse(sessionStorage.getItem('task_plasmatic_p_discard')),
			  task_units_locked:JSON.parse(sessionStorage.getItem('task_units_locked')),
			  task_unit_transfer:JSON.parse(sessionStorage.getItem('task_unit_transfer')),
			  task_summary_campaigns:JSON.parse(sessionStorage.getItem("task_general_summary")),
		    });

		}

	}

	openSocket(){
		console.log('open socket')
		socket= new WebSocket("wss://localhost:2018");

		socket.onerror = (event)=> {
			this.setState({disableStartBtn:true});
			sessionStorage.setItem("machine_name","NULL");
		};

		socket.onopen = (event)=> {
			socket.send("initfp");
		};

		socket.onclose = (e)=>{
			console.log('websocket disconnected:' + e.code + ' ' + e.reason + ' ' + e.wasClean);
		};

		socket.onmessage = (event) => {
			var res = JSON.parse(event.data);
			if(res.MachineName){
				sessionStorage.setItem("machine_name",res.MachineName);
				console.log(sessionStorage.getItem("machine_name"));
			}

			if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		}
	}

	componentDidUpdate(){
		setTimeout(()=>{
			$('input').each(function(x){
				$(this).attr('autocomplete', 'off');
			});
		}, 500);
		
	}

	onIdle(e){
		if(this.props.location.pathname.indexOf('/change_list') === -1 && this.props.location.pathname.indexOf('/login') === -1 ){
			console.log('cerrar sesion')
			this.handleLogout();
		}
	}

	getLookFeel(){
		//this.waiting_modal.handleShow('Cargando...')
		fetch(Config.default.apiGateway.URL+'look_and_feel',{
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('toke'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}
		}).then(response => {
			if(response !== undefined && response !== null){
				var R_b = this.hexToR(response.background_color);
				var G_b = this.hexToG(response.background_color);
				var B_b = this.hexToB(response.background_color);

				var R_f = this.hexToR(response.font_color1);
				var G_f = this.hexToG(response.font_color1);
				var B_f = this.hexToB(response.font_color1);

				if(response.icon_color !== null){
					var R_i = this.hexToR(response.icon_color);
					var G_i = this.hexToG(response.icon_color);
					var B_i = this.hexToB(response.icon_color);
				}else{
					var R_i = this.hexToR('#bababa');
					var G_i = this.hexToG('#bababa');
					var B_i = this.hexToB('#bababa');
				}

				document.title = response.page_name !== undefined ? response.page_name : 'HAP';


				this.setState({
					logo_1:'data:image/jpeg;base64,'+response.logo1, //'data:image/jpeg;base64,'+response.logo1,
					logo_2:'data:image/jpeg;base64,'+response.logo2,
					header_document:'data:image/jpeg;base64,'+response.header_document,
					background_color:R_b+','+G_b+','+B_b,
					font_color:R_f+','+G_f+','+B_f,
					icon_color:R_i+','+G_i+','+B_i,
				});

				var img = document.getElementById("logo_img")
				if(img !== null){
					img.getAttribute("src");
					setTimeout(function(){

					   if(img.width > img.height){
					   		if(img.width === 100){
					   			document.documentElement.style.setProperty('--w-image', '55px');
					   			document.documentElement.style.setProperty('--w-img-home', '15%');
					   		}else{
					   			document.documentElement.style.setProperty('--w-image', '100px');
					   			document.documentElement.style.setProperty('--w-img-home', '40%');
					   		}

						}else if(img.width < img.height){
							document.documentElement.style.setProperty('--w-image', '40px');
							document.documentElement.style.setProperty('--w-img-home', '13%');

						}else{
							document.documentElement.style.setProperty('--w-image', '45px');
							document.documentElement.style.setProperty('--w-img-home', '15%');
						}
					},0)
				}
					
				const dimensions = this.getImageDimensions('data:image/jpeg;base64,'+response.logo1);
				const dimensions2 = this.getImageDimensions('data:image/jpeg;base64,'+response.logo2);
				const head_dimentions = this.getImageDimensions('data:image/png;base64,'+response.header_document)
				
				var w_logo1 = '', w_logo2 = '';

				dimensions.then((d)=>{
					if(d.w > d.h){
						this.setState({w_logo1: 100});
					}else{
						this.setState({w_logo1: 50});
					}
				})

				dimensions2.then((d)=>{
					if(d.w > d.h){
						this.setState({w_logo2: 100});
					}else{
						this.setState({w_logo2: 50});
					}
				})
				
				head_dimentions.then((d)=>{
					if(d.w > d.h){
						this.setState({w_head: 500});
					}else{
						this.setState({w_head: 50});
					}
				})

				document.documentElement.style.setProperty('--primary', R_b+','+G_b+','+B_b);
				document.documentElement.style.setProperty('--font', R_f+','+G_f+','+B_f);
				document.documentElement.style.setProperty('--icon', R_i+','+G_i+','+B_i);

				if(document.getElementsByClassName("rc-menu").length > 0){
					document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-menu)';
					document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-menu)';
				}
				
				

				//this.waiting_modal.handleClose();
			}else{
				//this.waiting_modal.handleClose();
			}
		})
	}

	getImageDimensions(file) {
	  	return new Promise (function (resolved, rejected) {
	    	var i = new Image()
	    	i.src = file
	    	
	    	i.onload = function(){
	      		resolved({w: i.width, h: i.height})
	    	};
	  	})
	}

	hexToR(h) {return parseInt((this.cutHex(h)).substring(0,2),16)}
	hexToG(h) {return parseInt((this.cutHex(h)).substring(2,4),16)}
	hexToB(h) {return parseInt((this.cutHex(h)).substring(4,6),16)}
	cutHex(h) {return (h.charAt(0)=="#") ? h.substring(1,7):h}

	updatePermissions(){
		fetch(Config.default.apiGateway.URL+"access?health_facilities_id="+sessionStorage.getItem("health_facilities_id"), {
			method: "GET",
			headers: new Headers({
					'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
		})//.then((resp) => resp.json())
		.then((response) => {
			if(response.ok){
				return response.json();
			}
		})
		.then((data) => {
			if(data !== undefined){
				if(data.medical_staff !== null){
					var medical = {
						id:data.medical_staff.id,
						names: data.medical_staff.names,
						lastname1: data.medical_staff.lastname1,
						lastname2: data.medical_staff.lastname2
					};
				}else{
					var medical = {};
				}

				this.setState({
					permissions:data.permissions_user,
					task_has_user_profiles: data.task_has_user_profiles,
					lab_sections_has_user_profiles: data.lab_sections_has_user_profiles,
					medical_staff: medical,
					show_menu: data.user_menu_options,
					api_version:data.api_version,
					graphics: data.dashboard_graphics
				});


				this.setPermissionsMenu(data);


				var permmiso_control = data.task_has_user_profiles.findIndex(obj => obj.type === 'QUALITY_CONTROL');
				
				if(permmiso_control !== -1 && sessionStorage.getItem("interfaz") === "web"){
					fetch(Config.default.apiGateway.URL+'quality_control/check?hf_id='+sessionStorage.getItem('health_facilities_id'),{
						methid: 'GET',
						headers: new Headers({
							'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
							'Accept': 'application/json',
							'Content-Type': 'application/json',
						})
					}).then(res => {
						if(res.ok){
							return res.json();
						}else{
							res.text().then(msg => {
								swal('Error', msg, 'error');
							});
						}
					}).then(response => {
						if(response !== undefined){
							if(response.length > 0){

								var msg = "<label>Se tienen que realizar controles de control de calidad a los siguientes componentes:</label><div style='text-align:left'> ";
								msg += '<table class="table"><thead><tr><th>Componente<th><th>Cantidad</th></tr></thead><tbody>'
								response.map((res)=>{
									msg += '<tr><td>'+res.component+'</td><td>'+res.total+'</td></tr>';
								})
								msg += '</tbody></table>';
								swal({
									title: 'Alerta',
									html:true,
									text: msg,
									type: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#DD6B55',
									confirmButtonText: '¡Ir!',
									cancelButtonText: '¡Cancelar!',
									//closeOnConfirm: true,
									closeOnCancel: true
								}, (isConfirm)=>{
									if(isConfirm === true){
										this.props.history.push('/quality_control');
										
									}
								});
							}
						}
					})
				}


				sessionStorage.setItem("task_has_user_profiles", JSON.stringify(data.task_has_user_profiles));
				sessionStorage.setItem("lab_sections_has_user_profiles", JSON.stringify(data.lab_sections_has_user_profiles));
				sessionStorage.setItem("medical_staff", JSON.stringify(medical));
				
				if(data.permissions_user !== null){
					this.setState({
						task_vital_signs:this.getTask('vital_signs'),
						task_biometrics:this.getTask('CAPTURE_BIOMETRIC'),
						task_clinic_history:this.getTask('clinic_history'),
						task_extraction:this.getTask('extraction'),
						task_register:this.getTask('register'),
						task_general_summary:this.getTask('general_summary'),
						task_release_lock:this.getTask('release_lock'),
						task_screen_caller:this.getTask('screen_caller'),
						task_results_donation: this.getTask('results_donation'),
						task_validation_donation: this.getTask('validation_donation'),
						task_lab_antibodies: this.getTask('LAB_ANTIBODIES'),
						task_lab_phenotypes: this.getTask("LAB_PHENOTYPES"),
						//task_has_user_profiles: sessionStorage.setItem("task_has_user_profiles", JSON.stringify(data.task_has_user_profiles)),
						//lab_sections_has_user_profiles: sessionStorage.setItem("lab_sections_has_user_profiles", JSON.stringify(data.lab_sections_has_user_profiles)),
						//medical_staff: sessionStorage.setItem("medical_staff", JSON.stringify(medical)),
						task_unit_request: this.getTask('UNIT_REQUEST'),
						task_unit_send: this.getTask('UNIT_SEND'),
						task_centrifuge:this.getTask('CENTRIFUGE'),
						task_division:this.getTask('DIVISION'),
						task_transformation:this.getTask('TRANSFORMATION'),
						task_alicuots:this.getTask('ALICUOTS'),
						task_pools:this.getTask('POOLS'),
						task_recostitution:this.getTask('RECONSTITUTION'),
						task_cryoprecipitates:this.getTask('CRYOPRECIPITATES'),
						task_discard_units:this.getTask('DISCARD_UNITS'),
						
						task_external_bags:this.getTask('external_bags'),
						task_donor_samples:this.getTask('donor_samples'),
						task_sample_results:this.getTask('sample_results'),
						task_petitions:this.getTask('petitions'),
						task_patient_sample_results:this.getTask('patient_sample_results'),
						task_unit_entries:this.getTask('unit_entries'),
						task_plasmatic_product:this.getTask('PRODUCTS'),
						task_plasmatic_entries:this.getTask('ENTRIES'),
						task_plasmatic_p_storage:this.getTask('P_STORAGE'),
						task_plasmatic_p_discard:this.getTask('PLAS_DISCARDS'),
						task_promotion_campaign:this.getTask('CAMPAIGNS'),
						task_promotion_external_bags:this.getTask('BAG_ENTRIES_PROM'),
						task_units_locked:this.getTask('units_locked'),
						task_unit_transfer:this.getTask('unit_transfer'),
						task_summary_campaigns:this.getTask('summary_campaigns'),
						task_unit_delivered:this.getTask('unit_delivered'),
						task_unit_reserves:this.getTask('unit_reserves'),

						//Insumos
						supplies_storage: this.getTask('SUP_WAREHOUSE'),
						supplies_discards: this.getTask("SUP_DISCARDS"),
						supplies_entries: this.getTask("SUP_ENTRIES"),
						supplies: this.getTask("SUP_SUPPLIES"),
						supplies_output: this.getTask("SUP_EXIT")
					});
				}
			}
		})
	}

	setPermissionsMenu(data){
		var menu = this.state.menu;

		menu.map((m1, i)=>{
			m1.submenu.map((m2, j)=>{
				m2.submenu.map((m3, k)=>{
					var index = data.task_has_user_profiles.findIndex(obj => obj.type === m3.permission);

					if(index === -1){
						m3.show = false;
					}else{
						m3.show = true;
					}
				})
			})
		})

		this.setState({menu: menu});
	}

	getTask(task_key){
		var res = {};

		res.create = this.existTask(task_key,'create'); 
		res.read = this.existTask(task_key,'read'); 
		res.update = this.existTask(task_key,'update'); 
		res.delete = this.existTask(task_key,'delete'); 
		switch(task_key){
			case 'vital_signs':
				sessionStorage.setItem("task_vital_signs", JSON.stringify(res));
				break;
			case 'CAPTURE_BIOMETRIC':
				sessionStorage.setItem("task_biometrics", JSON.stringify(res));
				break;
			case 'clinic_history':
				sessionStorage.setItem("task_clinic_history", JSON.stringify(res));
				break;
			case 'extraction':
				sessionStorage.setItem("task_extraction", JSON.stringify(res));
				break;
			case 'register':
				sessionStorage.setItem("task_register", JSON.stringify(res));
				break;
			case 'general_summary':
				sessionStorage.setItem('task_general_summary', JSON.stringify(res));
				break;
			case 'release_lock':
				sessionStorage.setItem("task_release_lock", JSON.stringify(res));
				break;
			case 'screen_caller':
				sessionStorage.setItem("task_screen_caller", JSON.stringify(res));
				break;
			case 'results_donation':
				sessionStorage.setItem("task_results_donation", JSON.stringify(res));
				break;
			case 'validation_donation':
				sessionStorage.setItem("task_validation_donation", JSON.stringify(res));
				break;
			case 'LAB_ANTIBODIES':
				sessionStorage.setItem("task_lab_antibodies", JSON.stringify(res));
				break;
			case 'LAB_PHENOTYPES':
				sessionStorage.setItem("task_lab_phenotypes", JSON.stringify(res));
				break;
			case 'UNIT_REQUEST':
				sessionStorage.setItem("task_unit_request", JSON.stringify(res));
				break;
			case 'UNIT_SEND':
				sessionStorage.setItem("task_unit_send", JSON.stringify(res));
				break;
			case 'CENTRIFUGE':
				sessionStorage.setItem("task_centrifuge", JSON.stringify(res));
				break;
			case 'DIVISION':
				sessionStorage.setItem("task_division", JSON.stringify(res));
				break;
			case 'TRANSFORMATION':
				sessionStorage.setItem("task_transformation", JSON.stringify(res));
				break;
			case 'ALICUOTS':
				sessionStorage.setItem("task_alicuots", JSON.stringify(res));
				break;
			case 'POOLS':
				sessionStorage.setItem("task_pools", JSON.stringify(res));
				break;
			case 'RECONSTITUTION':
				sessionStorage.setItem("task_recostitution", JSON.stringify(res));
				break;
			case 'CRYOPRECIPITATES':
				sessionStorage.setItem("task_cryoprecipitates", JSON.stringify(res));
				break;
			case 'DISCARD_UNITS':
				sessionStorage.setItem("task_discard_units", JSON.stringify(res));
				break;
			
			case 'external_bags':
				sessionStorage.setItem("task_external_bags", JSON.stringify(res));
				break;
			case 'donor_samples':
				sessionStorage.setItem("task_donor_samples", JSON.stringify(res));
				break;
			case 'sample_results':
				sessionStorage.setItem("task_sample_results", JSON.stringify(res));
				break;
			case 'WAREHOUSE_UNITS':
				sessionStorage.setItem("task_warehouse_units", JSON.stringify(res));
				break;
			case 'TRACEABILITY_DONATIONS':
				sessionStorage.setItem("task_traceability_donations", JSON.stringify(res));
				break;
			case 'TRACEABILITY_UNITS':
				sessionStorage.setItem("task_traceability_units", JSON.stringify(res));
				break;
			case 'STORE_UNITS':
				sessionStorage.setItem("task_store_units", JSON.stringify(res));
				break;
			case 'petitions':
				sessionStorage.setItem("task_petitions", JSON.stringify(res));
				break;
			case 'patient_sample_results':
				sessionStorage.setItem("task_patient_sample_results", JSON.stringify(res));
				break;
			case 'INACTIVE_PLASMA':
				sessionStorage.setItem("task_inactive_plasma", JSON.stringify(res));
				break;
			case 'unit_entries':
				sessionStorage.setItem('task_unit_entries', JSON.stringify(res));
				break;
			case 'PRODUCTS' :
				sessionStorage.setItem('task_plasmatic_product', JSON.stringify(res));
				break;
			case 'ENTRIES' :
				sessionStorage.setItem('task_plasmatic_entries', JSON.stringify(res));
				break;
			case 'P_STORAGE' :
				sessionStorage.setItem('task_plasmatic_p_storage', JSON.stringify(res));
				break;
			case 'CAMPAIGNS' :
				sessionStorage.setItem('task_promotion_campaign', JSON.stringify(res));
				break;
			case 'BAG_ENTRIES_PROM' :
				sessionStorage.setItem('task_promotion_external_bags', JSON.stringify(res));
				break;
			case 'PLAS_DISCARDS' :
				sessionStorage.setItem('task_plasmatic_p_discard', JSON.stringify(res));
				break;
			case 'units_locked':
				sessionStorage.setItem('task_units_locked', JSON.stringify(res));
				break;
			case 'unit_transfer':
				sessionStorage.setItem('task_unit_transfer', JSON.stringify(res));
				break;
			case 'summary_campaigns':
				sessionStorage.setItem('task_summary_campaigns', JSON.stringify(res));
				break;
		}
		

		return res;
	}

	existTask(task_key, action){
		var res = false;
		for(var i =0; i < this.state.permissions.length;i++){
			if(this.state.permissions[i][0].submenu_key.toUpperCase() === task_key.toUpperCase()){

				for(var j =0; j < this.state.permissions[i].length;j++){

					if(this.state.permissions[i][j].label === action.toUpperCase()){
						res = true;
					}
				}
				break;
			}
		}

		return res;
	}

	userHasAuthenticated = authenticated => {
		this.setState({ isAuthenticated: authenticated });
	}

	handleLogout = async event => {

		fetch(Config.default.apiGateway.URL+'users/log_out',{ 
			method: 'POST',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
			})
		.then(response => response.json())
		.then(res => {
			console.log(res);
		})

		if(sessionStorage.getItem("generic_session_id") !== null){
			fetch(Config.default.apiGateway.URL+'users_generic/'+sessionStorage.getItem("generic_session_id"),{ 
					method: 'PUT',
					headers: new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
						'Accept': 'application/json',
						'Content-Type': 'application/json',
					})
				})
			.then(response => response.json())
			.then(res => {
				sessionStorage.setItem("token", ""); 
				this.userHasAuthenticated(false);
				this.props.history.push("/login");
			})
		}else{
			await Auth.signOut();
			localStorage.clear();
			sessionStorage.clear();
			socket.close();
			this.userHasAuthenticated(false);
			this.props.history.push("/login");
			
		}	
	};

	goHome = async event => {
		this.props.history.push("/transfusional_control");
	};

	generateReport(){
		if(this.state.hiddeToReport){
			this.setState({
				hiddeToReport:false
			});
			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-menu)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-menu)';
			document.documentElement.style.setProperty('--title-color', 'rgba(var(--primary), 0.80)');
			
		}else{
			this.setState({
				hiddeToReport:true
			});

			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-active)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-active)';
			document.documentElement.style.setProperty('--title-color', 'var(--color-active)');
			
		}
			
		this.props.history.push('/');
	}

	reload(){
		this.setState({
			hiddeToReport: true
		});

		setTimeout(()=>{
			document.getElementsByClassName("rc-menu")[0].style.backgroundColor = 'var(--bg-active)';
			document.getElementsByClassName("rc-menu")[0].style.color = 'var(--color-active)';
			document.documentElement.style.setProperty('--title-color', 'var(--color-active)');
		}, 800);
	}

	changePwd(){
		this.modal_pwd.handleShow();
	}

	getDocumentType(type){
		return fetch(Config.default.apiGateway.URL+'html_templates/check_print_type?hf_id='+
			sessionStorage.getItem('health_facilities_id')+'&file_type='+type,{
			method:'GET',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				return response;
			}
		})
	}

	printDocumentTemplate(obj, print){
		return fetch(Config.default.apiGateway.URL+'html_templates/print_document', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.blob();
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
				}
		})
		.then(response => {
			if(response !== undefined){
				
				if(!print){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = function() {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						socket.send('{"Operacion":"print", "Type":"laboratory", "File": "'+aux[1]+'"}');
					}
				}

				return response;
			}
		})
	}

	printDocumentExternal(obj, print){
		return fetch(Config.default.apiGateway.URL+'html_templates/print_external', {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				
				return res.blob();
				
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		})
		.then(response => {
			if(response !== undefined){
				if(!print){
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = function() {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						socket.send('{"Operacion":"print", "Type":"laboratory", "File": "'+aux[1]+'"}');
					}
				}

				return response;
				
			}
		})
	}

	printLabel(obj, print){
		return fetch(Config.default.apiGateway.URL+"labelsEditor", {
			method : 'post',
			body:JSON.stringify(obj),
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'
			})
		})
		.then(res => {
			if(res.ok){
				return res.blob();
			}else{
			  res.text().then(function(result) {
				swal('¡Error', result, 'error');
				return;
			  });
			}
		})
		.then(response => {
			if(response !== undefined){
				if(!print){
					//PREVIEW
					var fileURL = URL.createObjectURL(response);
					window.open(fileURL);
				}else{
					//PRINTER
					var reader = new FileReader();
					reader.readAsDataURL(response); 
					reader.onloadend = function() {
						var base64data = reader.result;  
						var aux = base64data.split(',');
						socket.send('{"Operacion":"print", "Type":"label_sample_patients", "File": "'+aux[1]+'"}');
					}
				}
				
				return true;
				
			}
		})
	}

	render() {
		const childProps = {
			isAuthenticated: this.state.isAuthenticated,
			userHasAuthenticated: this.userHasAuthenticated,
			task_vital_signs:this.state.task_vital_signs,
			task_biometrics:this.state.task_biometrics,
			task_clinic_history:this.state.task_clinic_history,
			task_extraction:this.state.task_extraction,
			task_register:this.state.task_register,
			task_release_lock:this.state.task_release_lock,
			task_screen_caller:this.state.task_screen_caller,
			task_general_summary:this.state.task_general_summary,
			task_results_donation:this.state.task_results_donation,
			task_validation_donation:this.state.task_validation_donation,
			task_lab_antibodies:this.state.task_lab_antibodies,
			task_lab_phenotypes:this.state.task_lab_phenotypes,
			task_has_user_profiles: this.state.task_has_user_profiles || JSON.parse(sessionStorage.getItem("task_has_user_profiles")),
			lab_sections_has_user_profiles: this.state.lab_sections_has_user_profiles,
			medical_staff: this.state.medical_staff,
			task_unit_request: this.state.task_unit_request,
			task_unit_send: this.state.task_unit_send,
			updatePermissions:this.updatePermissions,
			columns:this.state.columns,
			search: this.state.search,
			don_usr_llam:this.state.don_usr_llam,
			waiting: this.waiting_modal,
			task_centrifuge:this.state.task_centrifuge,
			task_division:this.state.task_division,
			task_transformation:this.state.task_transformation,
			task_alicuots:this.state.task_alicuots,
			task_pools:this.state.task_pools,
			task_recostitution:this.state.task_recostitution,
			task_cryoprecipitates:this.state.task_cryoprecipitates,
			task_discard_units:this.state.task_discard_units,
			task_external_bags:this.state.task_external_bags,
			task_donor_samples:this.state.task_donor_samples,
			task_sample_results:this.state.task_sample_results,
			task_petitions:this.state.task_petitions,
			task_patient_sample_results:this.state.task_patient_sample_results,
			show_menu:this.state.show_menu,
			task_unit_entries:this.state.task_unit_entries,
			hiddeToReport:this.state.hiddeToReport,
			reload: this.reload,
			logo_1:this.state.logo_1,
			logo_2:this.state.logo_2,
			header_document:this.state.header_document,
			background_color:this.state.background_color,
			font_color:this.state.font_color,
			w_logo1:this.state.w_logo1,
			w_logo2:this.state.w_logo2,
			w_head:this.state.w_head,
			getLookFeel:this.getLookFeel,
			task_plasmatic_product:this.state.task_plasmatic_product,
			task_plasmatic_entries: this.state.task_plasmatic_entries,
			task_plasmatic_p_storage: this.state.task_plasmatic_p_storage,
			task_promotion_campaign: this.state.task_promotion_campaign,
			task_promotion_external_bags: this.state.task_promotion_external_bags,
			task_plasmatic_p_discard:this.state.task_plasmatic_p_discard,
			task_units_locked:this.state.task_units_locked,
			task_unit_transfer:this.state.task_unit_transfer,
			task_summary_campaigns:this.state.task_summary_campaigns,
			task_unit_delivered:this.state.task_unit_delivered,
			task_unit_reserves:this.state.task_unit_reserves,
			getDocumentType: this.getDocumentType,
			printDocumentTemplate: this.printDocumentTemplate,
			printDocumentExternal: this.printDocumentExternal,
			printLabel: this.printLabel,
			socket:socket,
			graphics:this.state.graphics,
			supplies_storage:this.state.supplies_storage,
			supplies_entries: this.state.supplies_entries,
			supplies: this.state.supplies,
			supplies_discards: this.state.supplies_discards,
			supplies_output: this.state.supplies_output,
			openSocket:this.openSocket
		};

		var min = sessionStorage.getItem('min_logout') !== null ? 1000 * 60 * parseInt(sessionStorage.getItem('min_logout')) : 1000 * 60 * 1;
		return (
			<div>
				<IdleTimer
					ref={ref => this.idleTimer = ref}
					element={document}
					onIdle ={this.onIdle}
					debounce={500}
					timeout={min} />

					<div className="App col-md-12" style={{padding:'0px'}}>
						{this.state.isAuthenticated && sessionStorage.getItem('interfaz') === 'web' ? 
							<div className="col-md-12" style={{padding:'0px', background:'white'}}>
								<Menu onClick={this.handleClick} onOpenChange={onOpenChange} mode='horizontal'>
									<MenuItem key="0" search="logo" className="home">
										<div className="img-container">
											<Link to={'/'}>
												<img id='logo_img' src={this.state.logo_1} alt=""/>
											</Link>
										</div>
										{/*}
										<SvgIcon icon={home} className="menu-icon"/>
										<Link to={'/'}>INICIO</Link>*/}
									</MenuItem>
								


									{this.state.show_menu.donors ?
										<SubMenu title={
											<div><SvgIcon icon={userPlus} className="menu-icon"/><span>DONANTES</span></div>
										} key="2" popupOffset={[0, 0]}>
											{this.state.menu.map((menu, i)=>
												menu.submenu.map((m, i)=>
													(m.report  && this.state.hiddeToReport) &&
														<SubMenu key={'2-'+i} title={<span className="submenu-title-wrapper">{m.title}</span>}>
															{m.submenu.map((s, j)=>
																s.show ?
																	<MenuItem key={"2-"+i+"-"+j} search={s.search}><Link to={s.link}>{s.title}</Link></MenuItem>
																: null
															)}
														</SubMenu>
												)
											
											)}
											{/*this.state.hiddeToReport &&
												<SubMenu key="2-0" title={<span className="submenu-title-wrapper">REPORTES</span>}>
													{childProps.task_has_user_profiles !== null ?
														childProps.task_has_user_profiles.map((user)=>{
															return user.type !== undefined ?
																user.type === 'TIME_CONTROL' ?
																	<MenuItem key="2-0-11" search="time_control"><Link to={'time_control'}>Control de Tiempo</Link></MenuItem>
																: user.type === 'DONOR_DIRECTORY' ?
																	<MenuItem key="2-0-9" search="directory_donor"><Link to={'/directory_donor'}>Directorio Donantes</Link></MenuItem>
																: user.type === 'DONATIONS_BY_CENTER' ? 
																	<MenuItem key="2-0-1" search="donations_by_center"><Link to={'/donations_by_center'}>Donaciones por Centro</Link></MenuItem>
																: user.type === 'DONORS_AGE_GENDER' ?
																	<MenuItem key="2-0-2" search="donor_age_gender"><Link to={'/donor_age_gender'}>Donantes Edad y Género</Link></MenuItem>
																: user.type === 'DONATIONS_REGISTERED' ? 
																	<MenuItem key="2-0-3" search="donation_register"><Link to={'/donation_register'}>Donaciones Registradas</Link></MenuItem>
																: user.type === 'EXTRACTION_INCIDENTS'  ? 
																	<MenuItem key="2-0-10" search="extraction_incident"><Link to={'/extraction_incident'}>Donaciones con Incidentes de Extracción</Link></MenuItem>
																: user.type === 'DONORS_BY_SERVICE' ?
																	<MenuItem key="2-0-15" search="donor_by_service"><Link to={'/donor_by_service'}>Donantes por Servicio</Link></MenuItem>
																: user.type === 'SEROLOGY_INCIDENTS' ?
																	<MenuItem key="2-0-17" search="serology_incidents">
																		<Link to="/serology_incidents">Donaciones con Incidentes de Serología</Link>
																	</MenuItem>
																: user.type === 'DONORS_BY_CONVOKE_PLACES' ?
																	<MenuItem key="2-0-21" search="donors_convoke_place">
																		<Link to="/donors_convoke_place">Donantes por Lugar de Colecta</Link>
																	</MenuItem>													
																: user.type === 'GENERAL_INFORMATION' ? 
																	<MenuItem key="2-0-4" search="general_info"><Link to={'/general_info'}>Información General</Link></MenuItem>
																: user.type === 'BIOMETRIC_PRODUCTIVITY' ? 
																	<MenuItem key="2-0-5" search="hematologia_report"><Link to={'/hematologia_report'}>Informe de Hematología</Link></MenuItem>
																: user.type === 'INCOME_BOOK' ?
																	<MenuItem key="2-0-12" search="income_book"><Link to={'/income_book'}>Libreta Ingresos</Link></MenuItem>
																: user.type === 'DONOR_STUDY_NOTEBOOK' ?
																	<MenuItem key="2-0-14" search="donor_study"><Link to={'/donor_study'}>Libreta Estudio de Donador</Link></MenuItem>
																: user.type === 'MEDICAL_PRODUCTIVITY_DETAILS' ?
																	<MenuItem key="2-0-18" search="medical_productivity_detail">
																		<Link to="/medical_productivity_detail">Productividad Médica Detallada</Link>
																	</MenuItem>
																: user.type === 'NURSE_PRODUCTIVITY' ?
																	<MenuItem key="2-0-19" search="nurse_productivity">
																		<Link to="/nurse_productivity">Productividad Extracción</Link>
																	</MenuItem>
																: user.type === 'MEDICAL_PRODUCTIVITY' ? 
																	<MenuItem key="2-0-6" search="medical_productivity"><Link to={'/medical_productivity'}>Productividad Médica</Link></MenuItem>
																: user.type === 'DONATION_REACTIONS' ?
																	<MenuItem key="2-0-7" search="reaction_donations"><Link to={'/reaction_donations'}>Reacciones a Donación</Link></MenuItem>
																: user.type === 'DONATIONS_SUMMARY' ? 
																	<MenuItem key="2-0-8" search="donation_summary"><Link to={'/donation_summary'}>Resumen Donaciones</Link></MenuItem>
																: user.type === 'CNTS_REPORT' ?
																	<MenuItem key="2-0-13" search="cnts_report"><Link to={'/cnts_report'}>Reporte CNTS</Link></MenuItem>
																: user.type === 'REPRINT_LABELS'  ? 
																	<MenuItem key="2-0-16" search="multiple_reprint"><Link to={'/multiple_reprint'}>Reimpresión de Etiquetas Múltiple</Link></MenuItem>
																: user.type === 'DIRECT_QUERIES' ?
																	<MenuItem key="2-0-20" search="special_queries">
																		<Link to="/special_queries">Reportes Especiales</Link>
																	</MenuItem>													
																: null 
															:null
														})
													: null}
												</SubMenu>
											}
											{this.state.hiddeToReport &&
												<SubMenu key="2-1" title={<span className="submenu-title-wrapper">ESTADÍSTICA</span>}>
													{childProps.task_has_user_profiles !== null ?
														childProps.task_has_user_profiles.map((user)=>{
															return user.type !== undefined ?
																user.type === 'DONATION_STATS' ?
																	<MenuItem key="2-1-1" search="stats_donors"><Link to={'/stats_donors'}>Estadística de Donadores</Link></MenuItem>
																: user.type === 'DONATIONS_BY_CENTER_STATS' ?
																	<MenuItem key="2-1-2" search="donor_by_center"><Link to={'/donor_by_center'}>Estadisticas Donadores por Centro</Link></MenuItem>
																: null
															:null
														})
													: null}
												</SubMenu>
													*/}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'PRE_OFFERS' ? 
															<MenuItem key="2-0" search="diary"><Link to={'/diary'}>Agenda</Link></MenuItem>
														: null
											      	:null
										    	})												
											:null}

											{childProps.task_register.read && !this.state.hiddeToReport ?
												<MenuItem key="2-1" search="register"><Link to={'/register'}>Registro</Link></MenuItem>
											:null  }
											{childProps.task_vital_signs.read && !this.state.hiddeToReport ?
												<MenuItem key="2-2" search="vital_signs"><Link to={'/vital_signs'} >Signos Vitales</Link></MenuItem>
										    :null }
											{childProps.task_biometrics.read && !this.state.hiddeToReport ?
												<MenuItem key="2-3" search="biometrics"><Link to={'/biometrics'}>Biometría Hemática</Link></MenuItem>
										    :null }
											{childProps.task_clinic_history.read && !this.state.hiddeToReport ?
												<MenuItem key="2-4" search="clinic_history"><Link to={'/clinic_history'}>Historia Clínica</Link></MenuItem>
											:null}
											{childProps.task_extraction.read && !this.state.hiddeToReport ?
												<MenuItem key="2-5" search="extractions"><Link to={'/extractions'}>Extracciones</Link></MenuItem>
											:null}
											{childProps.task_general_summary.read && !this.state.hiddeToReport ?
												<MenuItem key="2-6" search="offers"><Link to={'/offers'}>Resumen General</Link></MenuItem>
											:null}
											{childProps.task_release_lock.read && !this.state.hiddeToReport ?
												<MenuItem key="2-7" search="refuses"><Link to={'/refuses'}>Liberar Candados</Link></MenuItem>
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'REPRINT_LABELS'  ? 
															<MenuItem key="2-9" search="labels_list"><Link to={'/labels_list'}>Reimpresión de Etiquetas</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}

											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'MULTI_REPRINT_LABELS'  ? 
															<MenuItem key="2-29" search="multiple_reprint"><Link to={'/multiple_reprint'}>Reimpresión de Etiquetas Multiple</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}
											
											{childProps.task_external_bags.read && !this.state.hiddeToReport ?
												<MenuItem key="2-10" search="bag_entries"><Link to={'/bag_entries'}>Entrada Bolsas Externas</Link></MenuItem>
											:null}
											{childProps.task_donor_samples.read && !this.state.hiddeToReport ?
												<MenuItem key="2-11" search="samples"><Link to={'/samples'}>Registro Muestras</Link></MenuItem>
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'SEARCH_DONOR'  ? 
															<MenuItem key="2-12" search="search_donor"><Link to={'/search_donor'}>Buscar Donador</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'FUSION_DONORS'?
															<MenuItem key="2-13" search="fusion/donor"><Link to={'/fusion/donor'}>Fusión Donantes</Link></MenuItem>
														:null
													:null
												))	
											:null}
											
										</SubMenu>
									:null}
									{this.state.show_menu.laboratory ?
										<SubMenu title={
											<div><SvgIcon icon={lab} className="menu-icon"/><span>LABORATORIO</span></div>
										} key="3" popupOffset={[0, 0]}>
											{childProps.task_results_donation.read && !this.state.hiddeToReport ?
												<MenuItem key="3-1" search="results_donation"><Link to={'/results_donation'}>Resultados Donación</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'GROUP_STATS' ?
															<MenuItem key="3-1" search="group_stats"><Link to={'/group_stats'}>Estadística de Grupo</Link></MenuItem>
														: null
											      	:null
										    	})
											:null
											}
											{childProps.task_sample_results.read && !this.state.hiddeToReport ?
												<MenuItem key="3-2" search="sample_results"><Link to={'/sample_results'}>Resultados Muestras</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'LAB_SECTION_STATS' ?
															<MenuItem key="3-2" search="analitical_test_stats"><Link to={'/analitical_test_stats'}>Estadistica de Pruebas Analiticas</Link></MenuItem>
														: null
											      	:null
										    	})
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'WORK_LIST' ? 
															<MenuItem key="3-3" search="work_list"><Link to={'/work_list'}>Listas de Trabajo</Link></MenuItem>
														: null
											      	:null
										    	})
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'REPORT_INMUNO' ?
															<MenuItem key="3-3" search="blood_groups"><Link to={'/blood_groups'}>Reporte Inmunohematologica</Link></MenuItem>
														: null
											      	:null
										    	})
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'CASCADE_VALIDATION'  ? 
											          		<MenuItem key="3-4" search="validation_donation"><Link to={'/validation_donation'}>Validación Donación</Link></MenuItem>	
											        	: null
											      	:null
										    	})
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'REPORT_SEROLOGY' ? 
															<MenuItem key="3-4" search="serology_report"><Link to={'/serology_report'}>Reporte Serologia</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null }
										    {childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
										    	childProps.task_has_user_profiles.map((user)=>{
											    	return user.type !== undefined ?
											    		user.type === 'SAMPLES_SEARCH' ?
															<MenuItem key="3-5" search="sample_search"><Link to={'/sample_search'}>Búsqueda Muestras</Link></MenuItem>
														:null
											    	:null
											    })
											: this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'SEROLOGY_HIMFG' ?
															<MenuItem key="3-5" search="serology_himfg"><Link to={'/serology_himfg'}>Serologia HIMFG</Link></MenuItem>
														:null
													:null
												))
										    :null}
										    {childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
										    	childProps.task_has_user_profiles.map((user)=>{
											    	return user.type !== undefined ?
											    		user.type === 'DONORS_SEARCH' ?
															<MenuItem key="3-6" search="donors_search"><Link to={'/donors_search'}>Modificar Grupo y Fenotipo</Link></MenuItem>
														:null
											    	:null
											    })
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PENDING_VALIDATION' ?
															<MenuItem key="3-6" search="pending_validation"><Link to={'/pending_validation'}>Pendiente de Validación</Link></MenuItem>
														:null
													:null
												))
											
										    :null}

										    {!this.state.hiddeToReport?
												<MenuItem key="3-7" search="epidemiological_monitoring">
												<Link to={'/epidemiological_monitoring'}>Seguimiento Epidemiológico</Link></MenuItem>
											
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'NOTES_REPORT' ?
															<MenuItem key="3-7" search="donor_patient_note"><Link to={'/donor_patient_note'}>Reporte de Notas de Donantes y Pacientes</Link></MenuItem>
														:null
													:null
												))
											
										    :null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'BANK_SUMMARY' ?
															<MenuItem key="3-8" search="bank_summary"><Link to={'/bank_summary'}>Resumen de Banco</Link></MenuItem>
														:null
													:null
												))
											
										    :null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'GROUP_RH_REPORT' ?
															<MenuItem key="3-9" search="group_rh_report"><Link to={'/group_rh_report'}>Grupo y RH de Donadores</Link></MenuItem>
														:null
													:null
												))
											
										    :null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'EPI_MONITORING_REPORT' ?
															<MenuItem key="3-10" search="epi_monitoring_report"><Link to={'/epi_monitoring_report'}>Seguimiento Epidemiológico</Link></MenuItem>
														: user.type === 'HEADSHIP_VALIDATION_REPORT' ?
															<MenuItem key="3-10" search="headship_validation_report"><Link to={'/headship_validation_report'}>Validación Jefatura</Link></MenuItem>
														: null
													:null
												))
											
										    :null}
										</SubMenu>
									:null}
									{this.state.show_menu.processed ?
										<SubMenu title={
											<div><SvgIcon icon={cogs} className="menu-icon"/><span>PROCESADO</span></div>
										} key="4" popupOffset={[0, 0]}>
											{childProps.task_centrifuge.create && !this.state.hiddeToReport ?
												<MenuItem key="4-1" search="centrifuge"><Link to="/centrifuge">Centrifugado</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'REPORT_ALICUOTS' ? 

															<MenuItem key="4-1" search="made_aliquots"><Link to={'/made_aliquots'}>Alicuotas Realizadas</Link></MenuItem>

														: null
											      	:null
										    	})

										    :null }
											{childProps.task_division.create && !this.state.hiddeToReport ?
												<MenuItem key="4-2" search="fractioning"><Link to="/fractioning">Fraccionamiento</Link></MenuItem>
										    : childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'DISCARD_UNITS' ? 

															<MenuItem key="4-2" search="discard_unit"><Link to={'/discard_unit'}>Baja Unidades</Link></MenuItem>

														: null
											      	:null
										    	})
										    
										    :null}
											{/*<MenuItem key="4-3" search="bags_group"><Link to="/bags_group">Grupo en Bolsa</Link></MenuItem>*/}
											{childProps.task_transformation.create && !this.state.hiddeToReport ?
												<MenuItem key="4-3" search="modify_component"><Link to="/modify_component">Modificación</Link></MenuItem>									
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'OBTAINED_COMPONENTS' ? 

															<MenuItem key="4-3" search="obtained_components"><Link to={'/obtained_components'}>Componentes Obtenidos</Link></MenuItem>

														: null
											      	:null
										    	})

											:null}
											{childProps.task_alicuots.read && !this.state.hiddeToReport ?
												<MenuItem key="4-4" search="aliquots"><Link to={'/aliquots'}>Alicuotas</Link></MenuItem>
											: childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'DISCARD_UNITS_STATS' ? 
															<MenuItem key="4-4" search="discard_stats"><Link to={'/discard_stats'}>Estadistica Baja Unidades</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null }
											{childProps.task_pools.read && !this.state.hiddeToReport ?
												<MenuItem key="4-5" search="pools_list"><Link to={'/pools_list'}>Pools</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'DIVISION_PROGRAM' ? 

															<MenuItem key="4-5" search="fraction_units"><Link to={'/fraction_units'}>Unidades Fraccionadas</Link></MenuItem>

														: null
											      	:null
										    	})
											:null}
											{childProps.task_recostitution.create && !this.state.hiddeToReport ?
												<MenuItem key="4-6" search="reconstitucion"><Link to={'/reconstitucion'}>Reconstitución</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'CRIOPRECIPITATES' || user.type === 'CRYOPRECIPITATES'? 
															<MenuItem key="4-6" search="made_crioprecipitate"><Link to={'/made_crioprecipitate'}>Crioprecipitados</Link></MenuItem>
														: null
											      	:null
										    	})
											:null}
											
											{childProps.task_cryoprecipitates.read && !this.state.hiddeToReport ?
												<MenuItem key="4-7" search="cryoprecipitate_list"><Link to={'/cryoprecipitate_list'}>Crioprecipitados</Link></MenuItem>
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'POOL_PROCESS' ?

															<MenuItem key="4-7" search="pools_report"><Link to={'/pools_report'}>Pools</Link></MenuItem>

														: null
											      	:null
										    	})
											:null}
											{childProps.task_discard_units.read && !this.state.hiddeToReport ?
												<MenuItem key="4-8" search="discard_units_list"><Link to={'/discard_units_list'}>Baja Unidades</Link></MenuItem>
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'MODIFY_UNITS' ? 
															<MenuItem key="4-9" search="modify_fractioning"><Link to="/modify_fractioning">Editar Volúmenes</Link></MenuItem>
														: null
											      	:null
										    	})		
									    	: null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'PRINT_BAG_LABEL' ?

															<MenuItem key="4-10" search="print_labels"><Link to={'/print_labels'}>Impresión de Etiquetas</Link></MenuItem>

														: null
											      	:null
										    	})
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'CONFIRM_LABEL' ?
															<MenuItem key="4-11" search="label_confirm"><Link to={'/label_confirm'}>Confirmación de Etiquetado </Link></MenuItem>
														:null
													:null
												))
											: this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'TRANSFORMATION_PROCESS' ?
															<MenuItem key="4-11" search="transformation_process"><Link to={'/transformation_process'}>Modificación de Componente </Link></MenuItem>
														:null
													:null
												))
												
											:null}
											{!this.state.hiddeToReport && childProps.task_units_locked.read ?
												<MenuItem key="4-12" search="lock_units"><Link to={'/lock_units'}>Bloqueo de unidades</Link></MenuItem>
											:null}
											

											{/*!this.state.hiddeToReport ?

												<MenuItem key="4-10" search="print_labels"><Link to={'/print_labels'}>Impresión de Etiquetas</Link></MenuItem>

											:null*/}
											{/*<MenuItem key="4-10">Utilidades</MenuItem>*/}
										</SubMenu>
									:null}
									{this.state.show_menu.warehouse ?
										<SubMenu title={
											<div style={this.state.line_warehouse ? 
												{borderBottom:'3px solid red'} 
												: {borderBottom:'0px solid red'}}
												>
												<SvgIcon icon={eyedropper} className="menu-icon"/>
												<span>ALMACÉN</span>
											</div>
										} key="5" popupOffset={[0, 0]}
											
										>
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'UNITS'? 
															<MenuItem key="5-1" search="warehouse"><Link to={'/warehouse'}>Unidades</Link></MenuItem>
														: null
											      	:null
										    	})
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'WAREHOUSE_REPORT' ? 
															<MenuItem key="5-1" search="inventory">
																<Link to={'/inventory'}>Inventario</Link>
															</MenuItem>
														: null
											      	:null
										    	})

											:null}

											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'WAREHOUSE_UNITS'  ? 
															<MenuItem key="5-2" search="warehouse/units">
																<Link to={'/warehouse/units'}>Unidades de Almacén</Link>
															</MenuItem>
														: null
											      	:null
										    	})
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'TRACEABILITY_DONATIONS' ? 
															<MenuItem key="5-2" search="details_traceability">
																<Link to={'/details_traceability'}>Trazabilidad Detallado</Link></MenuItem>
														: null
											      	:null
										    	})
											:null}
											{/*childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'TRACEABILITY_DONATIONS'  ? 
															<MenuItem key="5-3" search="warehouse/donation_traceability">
																<Link to={'/warehouse/donation_traceability'}>Trazabilidad Donación</Link>
															</MenuItem>
														: null
											      	:null
										    	})
											:null*/}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'TRACEABILITY_UNITS' ? 
															<MenuItem key="5-4" search="simple_traceability">
																<Link to={'/simple_traceability'}>Trazabilidad Unidades Simple</Link>
															</MenuItem>
														: null
											      	:null
										    	})
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'TRACEABILITY_USERS' ? 
															<MenuItem key="5-5" search="user_traceability">
																<Link to={'/user_traceability'}>Trazabilidad Usuario</Link>
															</MenuItem>
														: null
											      	:null
										    	})
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'STORE_UNITS'  ? 
															<MenuItem key="5-6" search="warehouse/storeUnits">
																<Link to={'/warehouse/storeUnits'}>Almacenar Unidades</Link>
															</MenuItem>
														: null
											      	:null
										    	})
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null? 
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'UNITS_EXPIRED' ?
															<MenuItem key="5-7" search="expired_units">
																<Link to={'/expired_units'}>
																	<div style={this.state.line_warehouse ? 
																		{borderBottom:'3px solid red'} 
																		: {borderBottom:'0px solid red'}}>
																		Unidades Caducadas
																	</div>
																</Link>
															</MenuItem>
														:null
													:null
												))
															
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null? 
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'UNITS_PROX_EXPIRED' ?
															<MenuItem key="5-8" search="units_near_expiration">
																<Link to={'/units_near_expiration'}>Unidades Proximas a Caducar</Link>
															</MenuItem>
														:null
													:null
												))
															
											:null}
										</SubMenu>
									:null}
									{this.state.show_menu.distribution ?
										<SubMenu title={
											<div><SvgIcon icon={ic_cached} className="menu-icon"/><span>DISTRIBUCIÓN</span></div>
											
										} key="6" popupOffset={[0, 0]}>
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												/*childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'INACTIVE_PLASMA' ? 
															<MenuItem key="6-1" search="plasma"><Link to={'/plasma'}>Plasma inactivar</Link></MenuItem>
														: null
											      	:null
										    	})*/
										    	null
											:childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'REPORT_EXPENSES' ?
															<MenuItem key="6-1" search="expenses"><Link to={'/expenses'}>Egresos</Link></MenuItem>
														: null
											      	:null
										    	})
											:null}
										    {childProps.task_unit_request.read && !this.state.hiddeToReport ?
										    	<MenuItem key="6-2" search="distribution"><Link to={'/distribution'}>Pedidos Unidades</Link></MenuItem>
										    : childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'UNITS_SUPPLIED_STATS' ?
															<MenuItem key="6-2" search="supplied_units_stats"><Link to={'/supplied_units_stats'}>Estadistica Unidades Suministradas</Link></MenuItem>
														: null
											      	:null
										    	})
										    
											:null}
											{childProps.task_unit_send.read && !this.state.hiddeToReport ?
										    	<MenuItem key="6-3" search="shippings"><Link to={'/shippings'}>Envío Unidades</Link></MenuItem>
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'INCOMINGS_REPORT' ?
															<MenuItem key="6-3" search="income"><Link to={'/income'}>Ingresos</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}
										    {childProps.task_unit_entries.read && !this.state.hiddeToReport ?
										    	<MenuItem key="6-4" search="entry_units"><Link to={'/entry_units'}>Entrada de Unidades</Link></MenuItem>
										    
										    : childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'UNIT_SEND_BY_CENTER' ?
															<MenuItem key="6-4" search="units_by_center"><Link to={'/units_by_center'}>Unidades por Centro</Link></MenuItem>
														: null
											      	:null
										    	})
										    
										    :null}
										    {childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'UNIT_CORRECTION'  ? 
															<MenuItem key="6-5" search="units_correction"><Link to={'/units_correction'}>Corrección de Unidades</Link></MenuItem>
														: null
											      	:null
										    	})
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'UNIT_RECEIVED' ?
															<MenuItem key="6-5" search="units_received"><Link to={'/units_received'}>Unidades Recibidas</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}
										    {childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'INIT_LOAD' ? 
															<MenuItem key="6-6" search="initial_load"><Link to={'/initial_load'}>Carga inicial</Link></MenuItem>
														: null
											      	:null
										    	})
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'GENERAL_EXPENSES' ?
															<MenuItem key="6-6" search="general_expenses"><Link to={'/general_expenses'}>Egresos Generales</Link></MenuItem>
														: null
											      	:null
										    	})
										    :null}
											{!this.state.hiddeToReport && childProps.task_unit_transfer.read ?
										    	<MenuItem key="6-7" search="unit_transfer"><Link to={'/unit_transfer'}>Traspaso Unidades</Link></MenuItem>
										    
										    :childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'SUPPLY_COMPONENTS' ? 
															<MenuItem key="6-7" search="component_supply"><Link to={'/component_supply'}>Abastecimiento de Componentes</Link></MenuItem>
														: null
											      	:null
										    	})
										    
										    :null}
										    {childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'SEARCH_EXIT_FOLIO' ? 
															<MenuItem key="6-8" search="delivered_search"><Link to={'/delivered_search'}>Búsqueda Envío</Link></MenuItem>
														: null
											      	:null
												})
											: childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
														user.type === 'SHIPMENTS_CANCELED' ? 
															<MenuItem key="6-8" search="shipments_canceled"><Link to={'/shipments_canceled'}>Envíos Cancelados</Link></MenuItem>
														: null
													:null
												})											
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
														user.type === 'TRANSFERS_TO_CENTRAL' ? 
															<MenuItem key="6-9" search="transfers_to_central"><Link to={'/transfers_to_central'}>Traspasos a Central</Link></MenuItem>
														: null
													:null
												})											
											:null}
										</SubMenu>
									:null}

									{this.state.show_menu.plasmatic_products ?
										<SubMenu title={<span>P. HEMOSTÁTICOS</span>} key="7" popupOffset={[0, 0]}>
											{childProps.task_plasmatic_p_storage.read && !this.state.hiddeToReport ?
												<MenuItem key="7-1" search="plasmatic_products/warehouse"><Link to={'/plasmatic_products/warehouse'}>Almacén</Link></MenuItem>
											:null}
											{childProps.task_plasmatic_p_discard.read && !this.state.hiddeToReport ?
												<MenuItem key="7-2" search="plasmatic_products/discard"><Link to={'/plasmatic_products/discard'}>Baja</Link></MenuItem>
											:null}
											{childProps.task_plasmatic_entries.read && !this.state.hiddeToReport ?
												<MenuItem key="7-3" search="entries_plasmatic_products"><Link to={'/entries_plasmatic_products'}>Entradas</Link></MenuItem>
											: this.state.hiddeToReport && childProps.task_has_user_profiles !== null? 
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PLASMATIC_KARDEX' ?
															<MenuItem key="7-3" search="plasmatic_kardex"><Link to={'/plasmatic_kardex'}>Kardex de Productos Plasmaticos</Link></MenuItem>
														:null
													:null
												))
											:null}

											{childProps.task_plasmatic_product.read && !this.state.hiddeToReport ?
												<MenuItem key="7-4" search="plasmatic_products"><Link to={'/plasmatic_products'}>Productos</Link></MenuItem>
											: this.state.hiddeToReport && childProps.task_has_user_profiles !== null? 
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PRODUCT_EXPORT' ?
															<MenuItem key="7-4" search="plasmatic_send"><Link to={'/plasmatic_send'}>Salida de Productos</Link></MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'INACTIVE_PLASMA' ? 
															<MenuItem key="7-5" search="plasmatic_products/plasma">
																<Link to={'/plasmatic_products/plasma'}>Plasma a Industrializar</Link>
															</MenuItem>
														: null
											      	:null
												})
											: this.state.hiddeToReport && childProps.task_has_user_profiles !== null? 
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PRODUCT_EXPORT_STATS' ?
															<MenuItem key="7-5" search="product_export_stats"><Link to={'/product_export_stats'}>Estadística de Productos Enviados</Link></MenuItem>
														:null
													:null
												))
											:null}

										</SubMenu>
									:null}

									{this.state.show_menu.supplies ?
										<SubMenu title="INSUMOS" key="19" popupOffset={[0, 0]}
											style={!this.state.hiddeToReport?
												this.state.line_plasmatic ? {borderBottom:'3px solid red'} 
												: {borderBottom:'0px solid red'}
											: {borderBottom:'0px solid red'}}>
											{childProps.supplies_storage.read && !this.state.hiddeToReport?
												<MenuItem key="19-1" search="supplies_reagents/warehouse">
													<Link to={'/supplies_reagents/warehouse'} style={this.state.line_plasmatic ? 
															{borderBottom:'3px solid red'} 
														: {borderBottom:'0px solid red'}}>	
														Almacén
													</Link>
												</MenuItem>
											:null}
											{ childProps.supplies_discards.read && !this.state.hiddeToReport?
												<MenuItem key="19-2" search="supplies_reagents/discard">
													<Link to={'/supplies_reagents/discard'}>Bajas</Link>
												</MenuItem>
											:null}
											{childProps.supplies_entries.read && !this.state.hiddeToReport?
												<MenuItem key="19-3" search="supplies_entries">
													<Link to={'/supplies_entries'}>Entradas</Link>
												</MenuItem>
											:null}
											{childProps.supplies.read && !this.state.hiddeToReport?
												<MenuItem key="19-4" search="supplies_reagents">
													<Link to={'/supplies_reagents'}>Insumos</Link>
												</MenuItem>
											:null}
											{childProps.supplies_output.read && !this.state.hiddeToReport?
												<MenuItem key="19-5" search="supplies_reagents/output">
													<Link to={'/supplies_reagents/output'}>Salidas</Link>
												</MenuItem>
											:null}
										</SubMenu>
									:null}

									{this.state.show_menu.patients ?
										<SubMenu title={
											<div><SvgIcon icon={users} className="menu-icon"/><span>PACIENTES</span></div>
										} key="8" popupOffset={[0, 0]}>
											{childProps.task_petitions.read && !this.state.hiddeToReport ?
												<MenuItem key="8-1" search="petition_register"><Link to={'/petition_register'}>Registro Peticiones</Link></MenuItem>
											:childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'DONORS_BY_PATIENTS' ?
															<MenuItem key="8-1" search="donor_by_patient"><Link to={'/donor_by_patient'}>Donantes por Paciente</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'WITHDRAW_RESERVATION' ?
															<MenuItem key="8-2" search="remove_reserve">
																<Link to={'/remove_reserve'}>Retirar Reserva</Link>
															</MenuItem>
														:null
													:null
												))

											: childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PATIENT_SEND' ? 
															<MenuItem key="8-2" search="sent_patient"><Link to={'/sent_patient'}>Envios a Paciente</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined ?
														user.type === 'FUSION_PATIENTS' ?
															<MenuItem key="8-3" search="fusion/patient"><Link to={'/fusion/patient'}>Fusión Paciente</Link></MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'UNITS_RESERVED_REPORT' ?
															<MenuItem key="8-3" search="reserved_units"><Link to={'/reserved_units'}>Unidades Reservadas</Link></MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'HEMOVIGILANCE' ?
															<MenuItem key="8-4" search="hemovigilance"><Link to={'/hemovigilance'}>Hemovigilancia</Link></MenuItem>
														:null
													:null
												))
											: childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'UNIT_DELIVERED_STATS' ?
															<MenuItem key="8-4" search="delivered_stats"><Link to={'/delivered_stats'}>Estadistica Unidades Enviadas</Link></MenuItem>
														:null
													:null
												)) 
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'SEARCH_PATIENT' ?
															<MenuItem key="8-5" search="patient_search"><Link to={'/patient_search'}>Buscar Paciente</Link></MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'DEBTS_REPORT' ?
															<MenuItem key="8-5" search="debts"><Link to={'/debts'}>Adeudos</Link></MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'SEARCH_PATIENT_SAMPLE' ?
															<MenuItem key="8-6" search="sample_patient_search"><Link to={'/sample_patient_search'}>Búsqueda Muestra</Link></MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'TRANS_UNIT_SEND' ?
															<MenuItem key="8-6" search="unit_delivered_transfuse"><Link to={'/unit_delivered_transfuse'}>Unidades Enviadas Transfundir</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'UNITS_RESERVED_SEARCH' ?
															<MenuItem key="8-7" search="reserved_search"><Link to={'/reserved_search'}>Búsqueda de Reservas</Link></MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'DISCHARGES_AND_DISCARDS' ?
															<MenuItem key="8-7" search="expenses_and_discards"><Link to={'/expenses_and_discards'}>Egresos y Descartes</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport ?
												null
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'EXPENSE_BOOK' ?
															<MenuItem key="8-8" search="expenses_book"><Link to={'/expenses_book'}>Libreta Egresos</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport ?
												null
											:childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'UNITS_RECEIVED_PAT' ?
															<MenuItem key="8-9" search="units_received_report"><Link to={'/units_received_report'}>Unidades Recibidas</Link></MenuItem>
														:null
													:null
												))
											:null}
											{this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'ANALITICAL_TEST_REPORT' ?
															<MenuItem key="8-10" search="patient/test_stats"><Link to={'/patient/test_stats'}>Estadistica de Pruebas</Link></MenuItem>
														:null
													:null
												))
											:null}
											{this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'PETITIONS_REPORT' ?
															<MenuItem key="8-11" search="patient/registered_petitions"><Link to={'/patient/registered_petitions'}>Peticiones Registradas</Link></MenuItem>
														:null
													:null
												))
											:null}
											{!this.state.hiddeToReport  && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'HEMOVIGILANCE_DASHBOARD' ?
															<MenuItem key="8-12" search="board_hemovigilancia">
														 		<Link to="/board_hemovigilancia">Tablero Hemovigilancia</Link>
														 	</MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'TRANSFUSIONAL_CONTRO_REPORT' ?
															<MenuItem key="8-12" search="patient/transfutional_control_report"><Link to={'/patient/transfutional_control_report'}>Informe Control Transfusional</Link></MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'HEMOVIGILANCE_DASHBOARD_V2' ?
															<MenuItem key="8-13" search="board_list">
														 		<Link to="/board_list">Tablero Hemovigilancia V2</Link>
														 	</MenuItem>
														: user.type === 'WORK_LIST_PATIENTS' ?
															<MenuItem key="8-22" search="work_list/patient">
																<Link to="/work_list/patient">Listas de Trabajo</Link>
															</MenuItem>
														: user.type === 'CASCADE_SAMPLES_VALIDATION' ?
															<MenuItem key="8-23" search="validation_donation/patient">
																<Link to="/validation_donation/patient">Validación Muestras</Link>
															</MenuItem>
														:null
													:null
												))
											:childProps.task_has_user_profiles !== null ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'SAMPLES_TRACEABILITY' ?
														//user.type === 'HEMOVIGILANCE_DASHBOARD_V2' ?
															<MenuItem key="8-13" search="samples_traceability">
														 		<Link to="/samples_traceability">Trazabilidad de Muestras</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														//user.type === 'SAMPLES_TRACEABILITY' ?
														user.type === 'TRANSFUSIONAL_INCIDENTS' ?
															<MenuItem key="8-14" search="incident_transfutional">
														 		<Link to="/incident_transfutional">Incidentes Transfusionales</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'KARDEX_HEMOVIG' ?
															<MenuItem key="8-15" search="kardex_hemovigilance">
														 		<Link to="/kardex_hemovigilance">Kardex Hemovigilancia</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'EXPENSES_INCOMES_BOOK' ?
															<MenuItem key="8-16" search="expenses_income_book"><Link to={'/expenses_income_book'}>Libreta Ingresos y Egresos</Link></MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														user.type === 'CROSSMATCH_TIME' ?
															<MenuItem key="8-17" search="crossmatch_time"><Link to={'/crossmatch_time'}>Reporte de Pruebas Cruzadas</Link></MenuItem>
														:null
													:null
												))
											:null}
											
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														//user.type === 'SAMPLES_TRACEABILITY' ?
														user.type === 'SHIPPING_STATISTICS' ?
															<MenuItem key="8-18" search="shipping_statics">
														 		<Link to="/shipping_statics">Estadística de Envíos</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}

											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														//user.type === 'SAMPLES_TRACEABILITY' ?
														user.type === 'TRANSFUTIONAL_STATS' ?
															<MenuItem key="8-19" search="hemovigilance_report">
														 		<Link to="/hemovigilance_report">Estadísticas de Transfusiones</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														//user.type === 'SAMPLES_TRACEABILITY' ?
														user.type === 'TRANSFUSION_DISCHARGES' ?
															<MenuItem key="8-20" search="transfusion_discharges">
														 		<Link to="/transfusion_discharges">Descargas Transfusionales</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>(
													user.type !== undefined?
														//user.type === 'petitions_by_service_stats' ?
														user.type === 'PETITIONS_BY_SERVICE_STATS' ?
															<MenuItem key="8-21" search="petitions_by_service_stats">
														 		<Link to="/petitions_by_service_stats">Estadistica Peticiones por Servicio</Link>
														 	</MenuItem>
														:null
													:null
												))
											:null}

											
										</SubMenu>
									:null}

									
									{this.state.show_menu.promotion ?
										<SubMenu title={<span>PROMOCIÓN</span>} key="11" popupOffset={[0, 0]}>
											{childProps.task_promotion_campaign.read && !this.state.hiddeToReport ?
												<MenuItem key="11-1" search="promotion/campaign"><Link to={'/promotion/campaign'}>Campañas</Link></MenuItem>
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'MESSAGES' ? 
															<MenuItem key="11-2" search="promotion/messages"><Link to={'/promotion/messages'}>Mensajes</Link></MenuItem>
														: null
											      	:null
										    	})										
											:null}
											{childProps.task_promotion_external_bags.create && !this.state.hiddeToReport ?
												<MenuItem key="11-3" search="promotion/external_bags"><Link to={'/promotion/external_bags'}>Entrada Bolsas</Link></MenuItem>
											:null}
											{childProps.task_summary_campaigns.read && !this.state.hiddeToReport ?
												<MenuItem key="11-4" search="promotion/offers"><Link to={'/promotion/offers'}>Registros en Campaña</Link></MenuItem>
											:null}
											
										</SubMenu>
									:null}

									{this.state.show_menu.quality_control ?
										<SubMenu title={<span>CONTROL CALIDAD</span>} key="12" popupOffset={[0, 0]}>
											{!this.state.hiddeToReport && childProps.task_has_user_profiles !== null?
												childProps.task_has_user_profiles.map((user)=>{
													
													return user.type !== undefined ?
														user.type === 'QUALITY_CONTROL' ?
															<MenuItem key="12-1" search="quality_control">
																<Link to={'/quality_control'}>Control de Calidad</Link></MenuItem>
														:null
													:null
												})
											:null}
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													return user.type !== undefined ?
											        	user.type === 'ST_REPORT' ? 
															<MenuItem key="12-2" search="st_report"><Link to={'/st_report'}>Volumen de Sangre Total</Link></MenuItem>
														: null
											      	:null
										    	})										
											:null}	
											{childProps.task_has_user_profiles !== null && this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													
													return user.type !== undefined ?
											        	user.type === 'QUALITY_COMPONENTS' ? 
															<MenuItem key="12-3" search="quality_component">
																<Link to={'/quality_component'}>Calidad de Componentes</Link>
															</MenuItem>
														: null
											      	:null
										    	})										
											:null}
											{childProps.task_has_user_profiles !== null && !this.state.hiddeToReport ?
												childProps.task_has_user_profiles.map((user)=>{
													
													return user.type !== undefined ?
											        	user.type === 'EQUIPMENT_TEMPERATURE' ? 
															<MenuItem key="12-4" search="equipment_temperature">
																<Link to={'/equipment_trmperature'}>Temperatura de Equipos</Link>
															</MenuItem>	
														: null
											      	:null
										    	})										
											:null}
															
										</SubMenu>
									:null}
									

									{this.state.show_menu.reports ?
										<MenuItem key="9" search="" onClick={this.generateReport} style={{cursor:"pointer"}}>
											<SvgIcon icon={this.state.hiddeToReport ? home : statsDots} style={{marginRight:"5px"}}/>
											{/*this.state.hiddeToReport ? 'PRINCIPAL' :'REPORTES'*/}
										</MenuItem>
									:null}

									<SubMenu key="10" popupOffset={[-105, 0]} title={
										<div>
											<SvgIcon icon={user} className="menu-icon"/>
											<span>{sessionStorage.getItem('user_name')}</span>
										</div>
									} style={{float:"right"}}>
										<MenuItem key="10-0" search="none">
											<Link to="" onClick={e => e.preventDefault()} style={{ pointerEvents: 'none' }}>
												<SvgIcon icon={desktop} className="menu-icon"/>
												Versión {this.state.api_version}
											</Link>
										</MenuItem>
										<MenuItem key="10-1" search="pass_change">
											<Link  onClick={this.changePwd} to="">
												<SvgIcon icon={cog} className="menu-icon"/>
												Cambio de Contraseña
											</Link>
										</MenuItem>
										<MenuItem key="10-2" search="singout">
											<Link onClick={this.handleLogout} to="" className="logout">
												<SvgIcon icon={exit} className="menu-icon"/>
												SALIR
											</Link>
										</MenuItem>
									</SubMenu>

									{/*}
									<MenuItem key="10">
										<SvgIcon icon={exit} className="menu-icon"/>
										<Link onClick={this.handleLogout} to="" className="logout">SALIR</Link>
									</MenuItem>
									<MenuItem key="11" search="no_search" style={{float:"right",paddingTop:"1px",paddingBottom:"1px"}}>
										<SvgIcon icon={user} size={35} style={{marginRight:'8px', verticalAlign:'top'}} />
										<div style={{display:'inline-block'}}>
											<span style={{display:"block",textAlign:"center"}}>{sessionStorage.getItem('user_name')}</span>
											<Link  onClick={this.changePwd} className="change-password" to="">
												Cambio de Contraseña
											</Link>
										</div>
									</MenuItem>*/}
								</Menu>
							</div> 
						/**MENU HANDHELD */
						:this.state.isAuthenticated && sessionStorage.getItem("user_type") === "USER_HANDHELD" && sessionStorage.getItem('interfaz') === 'movil'  ? 
						<div>
							<ButtonToolbar style={{float:"right",paddingRight:"30px"}}>
								<ButtonGroup>
									<Button className="btn btn-info" onClick={this.goHome}>
										<SvgIcon icon={home}/>
									</Button>
									<Button className="btn btn-info" onClick={this.handleLogout}>
										<SvgIcon icon={forward}/>
									</Button>
								</ButtonGroup>
							</ButtonToolbar>
						</div>
						:null}

						<MuiThemeProvider className="col-md-12">
							<Routes childProps={childProps} />
						</MuiThemeProvider>
						<MuiThemeProvider className="col-md-12">
							<ModalPassword {...this.props} waiting={this.waiting_modal} onRef={ref => (this.modal_pwd = ref)}/>
						</MuiThemeProvider>

						<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
						
					</div>
				
			</div>
		);
	}
}

export default withRouter(App);